import { useMutation } from '@tanstack/react-query'
import { useApiClient } from '@/shared/api'

export type GroupingType = 'voice' | 'experiment' | 'list'

export interface ReportMetricItem {
  groupKey: string
  generalMetrics: Record<string, number> | null
  techMetrics: Record<string, number> | null
  dispositionMetrics: Record<string, number>
  durationMetrics: Record<string, number>
  Minutes: number
  Cost: number
  'Cost per success': number
}

export interface ReportData {
  grouping: GroupingType
  startDateStr: string
  endDateStr: string
  listNames?: Record<string, string>
  data: ReportMetricItem[]
}

interface GenerateReportParams {
  campaignId: number
  startDate: string
  endDate: string
  grouping: GroupingType
}

/**
 * Hook to generate custom reports
 * Uses mutation since it's a user-triggered action, not automatic data fetching
 */
export function useGenerateReport() {
  const apiClient = useApiClient()

  return useMutation({
    mutationFn: async (params: GenerateReportParams): Promise<ReportData> => {
      const searchParams = new URLSearchParams({
        campaign_id: params.campaignId.toString(),
        start_date: params.startDate,
        end_date: params.endDate,
        grouping: params.grouping,
      })

      const response = await apiClient<ReportData>(`/reports?${searchParams.toString()}`)
      return response
    },
  })
}